export default "__VITE_PUBLIC_ASSET__b6f4562f__"